<template lang="pug">
	section.section.main-section
		.container.container-narrow
			title-comp(:name="$t('title.tickets')")

			article.message.is-success(v-if="emptyPage")
				.message-body
					| {{ $t('tickets.empty') }}

			article.message.is-danger(v-if="errorPage")
				.message-body
					| {{ $t('alert.error') }}

			p.control.has-text-centered.margin-bottom-md
				button.button.is-primary.button-right-icon(type="button" @click="openTicketModal")
					| {{ $t('button.new_ticket') }}
					span.icon.feather
						plus-icon

			.box(v-for="ticket in tickets" :key="ticket.uuid")
				.ticket-header
					strong.is-size-5-desktop {{ ticket.subject }}
					span {{ $t('tickets.last_update', { time: getDate(ticket.updated) }) }}

				p.margin-top-sm {{ ticket.message }}

				p.margin-top-md.padding-xs.ticket-reply-box(v-if="ticket.reply")
					span.ticket-reply {{ $t('tickets.reply').toUpperCase() }}
					br
					| {{ ticket.reply }}

			modal-comp(ref="modal" :title="$t('button.new_ticket')")
				.form-container
					.field
						label.label {{ $t('label.subject') }}
						.control
							input.input(type="text" v-model="subject" maxlength="100")

					.field
						label.label {{ $t('label.message') }}
						.control
							textarea.textarea(v-model="message" maxlength="4000")

					.field
						.control.has-text-centered
							button.button.is-primary(type="button" v-bind:class="buttonClass" @click="submitTicket")
								| {{ $t('button.submit') }}
								span.icon.feather
									chevron-right-icon

					article.message.is-danger(v-if="errorSubject" transition="fade")
						.message-body
							| {{ $t('alert.missing_subject') }}
					article.message.is-danger(v-if="errorMessage" transition="fade")
						.message-body
							| {{ $t('alert.missing_message') }}


</template>

<script>
import TitleComponent from '../components/TitleComponent.vue'
import ModalComponent from '../components/ModalComponent.vue'
import { ChevronRightIcon, PlusIcon } from 'vue-feather-icons'

export default {
	components: {
		TitleComp: TitleComponent,
		ModalComp: ModalComponent,
		ChevronRightIcon,
		PlusIcon
	},
	data() {
		return {
			emptyPage   : false,
			errorPage   : false,
			subject     : '',
			message     : '',
			errorSubject: false,
			errorMessage: false
		}
	},
	computed: {
		accessToken() {
			return this.$store.state.auth.accessToken
		},
		tickets() {
			return this.$store.state.ticket.tickets
		},
		loading() {
			return this.$store.state.ticket.loading
		},
		buttonClass() {
			return { 'is-loading': this.loading }
		}
	},
	mounted() {
		//this.$meta().setOptions({ title: this.$t("title.tickets") + ' | ' + this.$t("title.home") })
		if (this.tickets.length === 0) {
			this.refreshTickets()
		}
	},
	methods: {
		openTicketModal() {
			this.$refs.modal.open()
		},
		refreshTickets() {
			this.$store.dispatch('ticket/getTickets', this.accessToken).then(() => {
				this.emptyPage = false
				this.errorPage = false
			}).catch(err => {
				if (err.response && err.response.status) {
					switch (err.response.status) {
						case 404:
							this.emptyPage = true
							break
						case 500:
							this.errorPage = true
							break
						default:
							console.warn(err.response.status)
					}
				}
			})
		},
		submitTicket() {
			if (!this.subject) {
				this.errorSubject = true
				return
			}

			if (!this.message) {
				this.errorMessage = true
				return
			}

			if (this.loading) return
			this.$store.dispatch('ticket/submitTicket', { token: this.accessToken, subject: this.subject, message: this.message })
				.then(response => {
					this.$refs.modal.close()
					this.refreshTickets()
				})
				.catch(err => {
					console.error(err.message)
				})
		},
		getDate(timestamp) {
			const d = new Date(timestamp * 1000)
			const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
			const month = months[d.getMonth()]

			return d.getDate() + ' ' + this.$t('time.month.' + month) + ' ' + d.getFullYear()
		}
	},
	watch: {
		subject() {
			this.errorSubject = false
		},
		message() {
			this.errorMessage = false
		}
	}
}
</script>

<style lang="stylus" scoped>
	.box
		border 1px solid #DDD

	span.ticket-reply
		font-weight bold
		font-size 90%
	.ticket-reply-box
		border 1px solid #DDD
		border-radius .2rem
	.ticket-header
		display flex
		justify-content center
		align-items center

		strong
			flex 1
</style>
